<template>
	<v-row>
		<v-col cols="auto">
			<v-card>
				<v-card-title class="d-flex align-center">
					<v-icon
						icon="$test"
						start
					/>
					Create Test Invoices
				</v-card-title>
				<v-card-subtitle>
					Creates x number of users per domain and generates invoicerows for them for the selected time period
				</v-card-subtitle>
				<v-card-text>
					<v-row>
						<v-col cols="6">
							<v-slider
								v-model="userNumber"
								:label="'Number of users'"
								:min="1"
								:max="5"
								:step="1"
								thumb-color="primary"
								thumb-label
								show-ticks="always"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="4">
							<date-text-field
								v-model="startDateValue"
								:label="$gettext('Start Date Value')"
								variant="outlined"
							/>
						</v-col>
						<v-col cols="4">
							<date-text-field
								v-model="endDateValue"
								:label="$gettext('End Date Value')"
								variant="outlined"
							/>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						:loading="loading"
						color="primary"
						@click="createTestInvoices"
					>
						<translate>Create test invoices</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import {
	axios,
} from '../../../../services/axios-service';
import {
	debounce,
} from 'lodash';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'CreateTestInvoices',
	data () {
		return {
			loading: false,
			startDateValue: null,
			endDateValue: null,
			minDate: null,
			maxDate: null,
			userNumber: 2,
		};
	},
	created () {
		const date = new Date();
		const year = date.getFullYear();

		this.startDateValue = [year, '01', '01', ].join('-');
		this.endDateValue = [year, '12', '31', ].join('-');
	},

	methods: {
		displayError,

		/**
		 * Requests an export from the server and when it is returned makes it downloadable, otherwise shows the errors for the selection
		 *
		 * @returns {void}
		 * @protected
		 */
		createTestInvoices () {
			this.loading = true;
			axios.post('/api/v0/invoices/generatetestinvoices', {
				startDate: this.startDateValue,
				endDate: this.endDateValue,
				userNumber: this.userNumber
			})
				.then(() => {
					debounce(() => {
						window.location.href = '/bo/invoices';
					}, 200)();
				})
				.catch((error) => {
					this.displayError(this.$gettext('Unable to create invoices'));
					window.captureException(error);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>
